export default __webpack_public_path__ + "static/media/5.201c0b90.jpg";